document.addEventListener('DOMContentLoaded', () => {
    const openAccItem = document.querySelector('.faq__item.open .faq__acc-panel');

    if ( openAccItem ) {
        openAccItem.style.maxHeight = `${openAccItem.scrollHeight}px`;
    }
});

const accordionFaq = document.querySelectorAll('.faq__acc-title');

function faq(accord) {
    accord.forEach(element => {
        element.addEventListener('click', function H() {
            const desc = this.nextElementSibling;

            if (desc.style.maxHeight) {
                desc.style.maxHeight = null;
                this.classList.remove('open');
                this.parentNode.parentNode.classList.remove('open');
            } else {
                accord.forEach(element => {
                    element.classList.remove('open');
                    element.nextElementSibling.style.maxHeight = null;
                    element.parentNode.parentNode.classList.remove('open');
                });
                desc.style.maxHeight = `${desc.scrollHeight}px`;
                this.classList.toggle('open');
                this.parentNode.parentNode.classList.toggle('open');
            }
        });
    });
}
faq(accordionFaq);
